import { Component, OnInit } from '@angular/core';
import { StepComponent } from '../step.component';
import { UntypedFormControl } from '@angular/forms';
import { addRateFinderBreadcrumb } from '../../../../../../services/rate-finder-sentry';

@Component({
    selector: 'app-select-step',
    templateUrl: './select-step.component.html',
    styleUrls: ['./select-step.component.scss'],
    standalone: false
})
export class SelectStepComponent extends StepComponent implements OnInit {
  control: UntypedFormControl;

  ngOnInit() {
  }

  submit() {
    this.control.markAsTouched();

    if (this.control.status === 'INVALID') {
      addRateFinderBreadcrumb('validation_failure', { mode: 'form' }, 'warning');
      this.analyticsService.trackQuestionAnsweredInvalid();
      return;
    }
 
    this.analyticsService.trackQuestionAnswered();

    this.nextStep();
  }

}
